import React, { Dispatch, SetStateAction } from 'react';
import { Pagination as BSPagination } from 'react-bootstrap';

interface Props {
  firstPage: number,
  lastPage: number,
  page: number,
  setPage: Dispatch<SetStateAction<number>>,
}

export enum Position {
  Both = "both",
  Bottom = "bottom",
  Top = "top"
}

const Pagination = (props: Props) => {
  if (props.lastPage <= props.firstPage) return <></>;

  const handleClick = (event: React.MouseEvent<HTMLUListElement, MouseEvent>) => {
    const element = event.target as HTMLElement;
    let newPage = props.page.toString();
    if (element.tagName === "A") {
      newPage = element.dataset.page!;
    } else if (element.tagName === "SPAN") {
      if (element.parentElement?.tagName === "A") {
        newPage = element.parentElement.dataset.page!;
      }
    }
    if ("previous" === newPage) {
      props.setPage(props.page - 1);
    } else if ("next" === newPage) {
      props.setPage(props.page + 1);
    } else {
      props.setPage(parseInt(newPage));
    }
    // (productGrid.current! as HTMLElement).scrollIntoView({behavior: "smooth"});
  }

  const renderPaginationItems = () => {
    
    // Define a reducer that converts the set to a new list of pagination items.
    const reducer = (acc: Array<any>, cur: number, idx: number, src: Array<number>) => {
      if (src[idx-1] && src[idx-1] + 1 !== cur) {
        acc.push(<BSPagination.Ellipsis key={acc.length} disabled />);
      }
      acc.push(<BSPagination.Item key={acc.length} active={props.page===cur} data-page={cur}>{cur}</BSPagination.Item>);
      return acc;
    }

    // Determine the unique set of pagination items.
    const paginationItems = new Set([props.firstPage, props.page, props.lastPage]);

    // Add pagination items for specific cases.
    if (props.page > props.firstPage) paginationItems.add(props.page-1);
    if (props.page < props.lastPage) paginationItems.add(props.page+1);
    if (props.page === props.firstPage + 3) paginationItems.add(props.firstPage + 1);
    if (props.page === props.lastPage - 3) paginationItems.add(props.lastPage - 1);

    // Return a sorted item array.
    return Array
      .from(paginationItems)
      .sort((a,b) => a - b)
      .reduce(reducer, []);
  }

  return (
    <BSPagination className="justify-content-center mb-4" onClick={handleClick}>
      <BSPagination.Prev disabled={props.page===props.firstPage} data-page="previous" />
      {renderPaginationItems()}
      <BSPagination.Next disabled={props.page===props.lastPage} data-page={"next"} />
    </BSPagination>
  );
}

export default Pagination;